<div class="pager-header">
  <ng-content select="[pagerTitle]" />

  <div class="pager-controls">
    <span class="pager-range" aria-live="polite">{{ range() }}</span>
    @if (canPage()) {
      <button
        type="button"
        class="pager-arrow pager-prev"
        [attr.aria-label]="'Previous ' + itemLabel()"
        [disabled]="atStart()"
        (click)="previous()"
      >
        <rkt-icon name="chevron-left" aria-hidden="true" />
      </button>
      <button type="button" class="pager-arrow pager-next" [attr.aria-label]="'Next ' + itemLabel()" [disabled]="atEnd()" (click)="next()">
        <rkt-icon name="chevron-right" aria-hidden="true" />
      </button>
    }
  </div>
</div>

@if (visibleItems().length) {
  <div class="pager-items" [style.--pager-columns]="itemsVisible()">
    @for (item of visibleItems(); track $index) {
      <ng-container [ngTemplateOutlet]="itemTemplate().template" [ngTemplateOutletContext]="{ $implicit: item }" />
    }
  </div>
}
